import config from 'Cloud/config';
import classNames from 'clsx';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { updateAdvAfterDatalist } from 'reactApp/appHelpers/appHelpers';
import { HIDE_ADS } from 'reactApp/appHelpers/configHelpers';
import { ADS_TIMER_MS } from 'reactApp/constants';
import { useIntersectionObserver } from 'reactApp/hooks/useInterSectionObserver';
import { useShowAdsBannerTimer } from 'reactApp/hooks/useShowAdsBannerTimer';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { DisableButton } from 'reactApp/ui/AdvBanners/DisableButton/DisableButton';
import { sendGa } from 'reactApp/utils/ga';
import useResizeObserver from 'use-resize-observer/polyfilled';

import styles from './DatalistBanner.css';

const DOM_ID_AFTER_DATALIST = config.get('DOM_ID_AFTER_DATALIST');
const MIN_ITEMS_COUNT_PUBLIC = 1;
const MIN_ITEMS_COUNT_OTHERS = 12;

interface IProps {
    itemsCount: number;
}

let minHeight = 0;

export const DatalistBanner = ({ itemsCount }: IProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const storage = useSelector(getCurrentStorage);
    const isPublic = storage === EStorageType.public;
    const { isDocuments } = getStorage(storage);
    let minElements = itemsCount >= MIN_ITEMS_COUNT_OTHERS;
    if (isPublic) {
        minElements = itemsCount >= MIN_ITEMS_COUNT_PUBLIC;
    }
    const closedPages = !isDocuments;
    const showAdv = !HIDE_ADS && minElements && closedPages;
    const { ref, height } = useResizeObserver<HTMLDivElement>();
    const hasAdvFromRb = !!height;

    if (!minHeight && height) {
        minHeight = height + 58;
    }

    const onIntersecting = () => {
        setIsVisible(true);
    };
    const onIntersectingOut = () => {
        setIsVisible(false);
    };
    const refIntersection = useIntersectionObserver({ onIntersecting, onIntersectingOut, rootMargin: '30px' });

    const banner = useShowAdsBannerTimer({
        adsUpdateTimerMs: ADS_TIMER_MS,
        updateAds: () => updateAdvAfterDatalist(refIntersection?.current?.offsetWidth ?? null),
        suspendTimer: !(isVisible && showAdv),
        renderItem: () => <div ref={ref} id={DOM_ID_AFTER_DATALIST} />,
    });

    const sendGaClick = useCallback(() => {
        sendGa('adv', 'after-datalist', 'click', null, true);
    }, []);

    if (!showAdv) {
        return null;
    }

    return (
        <div
            ref={refIntersection}
            className={classNames({
                [styles.root]: true,
                [styles.hide]: !hasAdvFromRb,
                [styles.root_public]: isPublic,
            })}
            style={{ minHeight }}
        >
            {!isPublic && (
                <div className={styles.textWrap}>
                    <div className={styles.text}>Реклама</div>
                    <DisableButton text="Отключить" className={styles.btn} onClick={sendGaClick} id="datalist-ad" />
                </div>
            )}
            {banner}
        </div>
    );
};

DatalistBanner.displayName = 'DatalistBanner';
